module.exports = __webpack_public_path__ + "static/01-9ef73fcc7e71d66cb0d822c0e59cddbf.jpg";